import React, { useState, useEffect } from 'react'
import { viewStoriesHome } from '../../actions/userActions'
import inMemoryJWT from '../../auth/inMemoryJwt';
import { useDispatch, useSelector } from 'react-redux';
import StoryBar from '../../containers/Home/StoryBar/StoryBar'
import useModal from '../../utils/hooks/useModal'
import CreateNewStory from '../../components/Stories/CreateNewStory'

import StoriesBarNew from './StoriesBarNew';

const StoriesBar = ({ }) => {
    const dispatch = useDispatch()
    const { isLoadingStoriesHomeList, storiesHomeList,userInfo } = useSelector((state) => state.userInfo);

    const [refNewStory, isVisibleNewStory, setIsVisibleNewHistory] = useModal()
    const [refShowStories, isShowStories, setIsShowStories] = useModal()
    const [storiesHome, setStoriesHome] = useState([])
    const [storyData, setStoryData] = useState([])
    const [currenStoryView, setCurrenStoryView] = useState(0)
    const [currenSubStory, setCurrenSubStory] = useState(0)
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        inMemoryJWT.waitForTokenRefresh().then(() => {
            dispatch(viewStoriesHome())
        })
    }, [])


    useEffect(() => {
        setStoriesHome([])
        setStoryData([])

        if (!isLoadingStoriesHomeList) {
            if (storiesHomeList.ownStories.length > 0) {
                
                setStoriesHome(prevState => [...prevState, {
                    id: storiesHomeList.ownStories[0]._id,
                    friend:false,
                    idUser:  storiesHomeList.ownStories[0].representativeID ? storiesHomeList.ownStories[0].representativeID._id : storiesHomeList.ownStories[0].franchiseID ? storiesHomeList.ownStories[0].franchiseID._id : storiesHomeList.ownStories[0].userID._id,
                    //                    idUser: storiesHomeList.ownStories[0].userID._id,
                   
                    name: storiesHomeList.ownStories[0].userID?.name ?
                     storiesHomeList.ownStories[0].userID?.name : 
                    storiesHomeList.ownStories[0].franchiseID ? storiesHomeList.ownStories[0].franchiseID.socialReason :
                    storiesHomeList.ownStories[0].representativeID.name
                    ,
                    url: storiesHomeList.ownStories[0]?.multimedia[0]?.url?.origin,
                    type: storiesHomeList.ownStories[0]?.multimedia[0]?.type,
                    picture: storiesHomeList.ownStories[0].userID ? 
                    storiesHomeList.ownStories[0].userID.picture :
                     storiesHomeList.ownStories[0].franchiseID ? 
                     storiesHomeList.ownStories[0].franchiseID.picture :"", 

                }])
                var storiesVar = []
                storiesHomeList.ownStories.map((stories, index) => {
                    stories.multimedia.map((multimedia, index) => {
                        let id = null
                        let name = ""
                        let lastname = ""
                        let picture = ""
                        if (stories.userID) {
                            name = stories.userID.name
                            lastname = stories.userID.lastname
                            picture = stories.userID?.picture && stories.userID?.picture.url ? stories.userID?.picture.url.small : stories.userID?.picture
                        }



                        if (stories.franchiseID) {
                            name = stories.franchiseID.socialReason
                            picture = stories.franchiseID?.picture && stories.franchiseID?.picture.url ? stories.franchiseID?.picture.url.small : stories.franchiseID?.picture
                        }

                        if (stories.userID) {

                        }
                        if (stories.userID) {

                        }
                        storiesVar.push({
                            url: multimedia.url.origin,
                            id: stories._id,
                            archived: stories.archived,
                            type: multimedia.type.includes('video') ? 'video' : 'image',
                            urlThumb: multimedia?.url?.thumbnail,
                            duration: 5000,
                            header: {
                                heading: name,
                                headingLast: stories.userID?.lastname ? stories.userID.lastname : "",
                                profileImage:picture
                            }
                        })
                    })
                })
                setStoryData(prevState => [...prevState, storiesVar])
            }

        }

        if (!isLoadingStoriesHomeList) {
            storiesHomeList.friendStories.map((friendStory, index) => {
                if (friendStory) {
                    setStoriesHome(prevState => [...prevState, {
                        name: friendStory.user.name ?  friendStory.user.name :  friendStory.user.socialReason,
                        user: friendStory.user,
                        friend:true,
                        picture: friendStory.user.picture,
                        url: friendStory.stories[0].multimedia[0]?.url?.origin,
                        urlThumb: friendStory.stories[0].multimedia[0]?.url?.thumbnail,
                        type: friendStory.stories[0]?.multimedia[0]?.type,
                    }])
                    var storiesVar = []
                    friendStory.stories.map((stories, index) => {
                        stories.multimedia.map((multimedia, index) => {
                            storiesVar.push({
                                url: multimedia.url.origin,
                                urlThumb: multimedia?.url?.thumbnail,
                                id: stories._id,
                                friend:true,
                                user: stories.userID,
                                archived: stories.archived,
                                type: multimedia.type.includes('video') ? 'video' : 'image',
                                duration: 5000,
                                header: {
                                    heading:  friendStory.user.name ? friendStory.user.name :  friendStory.user.socialReason,
                                    headingLast: friendStory.user.lastname,
                                    profileImage: friendStory.user.picture && friendStory.user.picture.url ? friendStory.user.picture.url.small : friendStory.user.picture,
                                },
                            })
                        })
                    })
                    setStoryData(prevState => [...prevState, storiesVar])
                }
            })
        }

    }, [storiesHomeList])

    return (
        <>
            {
                isVisibleNewStory &&
                <CreateNewStory setIsVisibleNewStory={setIsVisibleNewHistory} refStory={refNewStory} />
            }
          
            {
                true && isShowStories &&
                <StoriesBarNew
                    stories={storiesHome}
                    refShowStories={refShowStories}
                    storyData={storyData}
                    currenStoryView={currenStoryView}
                    setCurrenStoryView={setCurrenStoryView}
                    currenSubStory={currenSubStory}
                    setIsShowStories={setIsShowStories}
                    setCurrenSubStory={setCurrenSubStory}
                />
            }
            <StoryBar
                currenSubStory={currenSubStory}
                setCurrenSubStory={setCurrenSubStory}
                stories={storiesHome}
                handleNewStory={setIsVisibleNewHistory}
                handleViewStory={setIsShowStories}
                setCurrenStoryView={setCurrenStoryView}
            />
        </>
    )
}

export default StoriesBar
